<div class="modal-content" style="padding-bottom: 50px; padding: 3em 4.5em">
  <div class="d-flex justify-content-between mx-auto" style="margin-bottom: 40px;width: 100%">
      <!-- Header Title -->
    <div class="d-flex flex-column">
        <p class="usb-modal-text--header mb-0 mt-2">
          {{ getFirstSegment()?.departure?.city }} / {{ getLastSegment()?.arrival?.city }} ({{ getStopsLabel() }})
        </p>
          <p class="usb-modal-txt--header mb-0 mt-0" style="font-weight: 500;">
             {{ formatDate(getFirstSegment()?.departure?.dateTime) }}
        </p>
    </div>
      <!-- Close Button -->
      <button type="button" class="close btn-closed" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true" style="font-size: 60px; font-weight: 100">&times;</span>
      </button>
    </div>

<div>

  <!-- TRAMO: resumen del tramo completo (todos los segmentos, con escalas) -->
  <div style="border: 1px solid #cdcdcd; border-top-right-radius: 8px; border-top-left-radius: 8px; overflow: hidden; margin-bottom: 1rem;">
    <div style="font-family: 'Poppins', sans serif;background-color: #cdcdcd; padding: 12px 16px; font-size: 14px; font-weight: 500; letter-spacing: .5px; color: black;">
      Tramo
    </div>

    <!-- Ruta completa: siempre todos los tramos encadenados, con la escala en
         el medio (si hay) en vez de alternar un tramo a la vez. -->
    <div class="d-flex align-items-center justify-content-between flex-wrap" style="margin-top: 30px; gap: 10px; padding: 0 20px;padding-bottom: 30px">

      <ng-container *ngFor="let segment of getAllSegments(); let i = index; let first = first; let last = last">

        <!-- Salida: sólo antes del primer tramo -->
        <div *ngIf="first" class="d-flex flex-column">
          <p class="date-info-result-flight-hour">{{ formatTime(segment?.departure?.dateTime) }}</p>
          <p class="date-info-result-flight-city">{{ segment?.departure?.city }}</p>
          <p class="date-info-result-flight-iata">{{ segment?.departure?.airport }}</p>
        </div>

        <!-- Tramo (vuelo): cabina/Nº de vuelo arriba, ícono + aerolínea abajo -->
        <div class="d-flex flex-column align-items-center" style="flex: 1; min-width: 150px;">
          <p class="date-info-result-flight-class mb-0">{{ segment?.cabin?.category }}</p>
          <p class="date-info-result-flight-segment mb-0">{{ segment?.airline?.code }} {{ segment?.flightNumber }}</p>

          <div class="d-flex align-items-center" style="width: 100%; gap: 15px;">
            <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;"></div>
            <img src="../../../../../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 48px;transform: rotate(90deg); flex-shrink: 0;margin-top:10px" alt="">
            <div style="height: 1px; border-bottom: 1px solid #cccccc; flex: 1;"></div>
          </div>

          <img class="date-info-result-image" style="margin-top: 6px;" [src]="segment?.airline?.operatingLogo" alt="">
        </div>

        <!-- Escala: entre este tramo y el siguiente -->
        <div *ngIf="!last" class="d-flex flex-column align-items-center" style="min-width: 110px;">
          <p class="mb-0" style="font-size: 12px; font-weight: 600;">Escala</p>
          <p class="mb-0" style="font-size: 12px;">{{ formatDuration(calculateLayover(i)) }}</p>
          <p class="mb-0" style="font-size: 13px; font-weight: 600;">
            {{ formatTime(segment?.arrival?.dateTime) }} / {{ formatTime(getAllSegments()[i + 1]?.departure?.dateTime) }}
          </p>
          <p class="date-info-result-flight-city mb-0">{{ segment?.arrival?.city }}</p>
          <p class="date-info-result-flight-iata mb-0">{{ segment?.arrival?.airport }}</p>
        </div>

        <!-- Llegada: sólo después del último tramo -->
        <div *ngIf="last" class="d-flex flex-column align-items-end">
          <p class="date-info-result-flight-hour">{{ formatTime(segment?.arrival?.dateTime) }}</p>
          <p class="date-info-result-flight-city">{{ segment?.arrival?.city }}</p>
          <p class="date-info-result-flight-iata">{{ segment?.arrival?.airport }}</p>
        </div>

      </ng-container>

    </div>

        <!-- Navegación por tramo (sólo si hay escalas) -->
        <div *ngIf="getAllSegments().length > 1" style="border-top: 1px solid #e9ecef;">
          <!-- Barra de progreso segmentada: un segmento por paso, pintado en
               negro sólo el activo (no una barra que se va llenando). -->
          <div class="d-flex" style="height: 6px;">
            <div
              *ngFor="let step of getTramoSteps(); let idx = index; trackBy: trackByIndex"
              [style.background-color]="idx === selectedStepIndex ? '#000000' : '#cdcdcd'"
              style="flex: 1; height: 100%; transition: background-color .2s ease;"
            ></div>
          </div>

          <!-- Los tramos/escalas son los botones: cada uno activa su paso
               directamente. La flecha entre dos steps es sólo un indicador
               de "siguiente"/"anterior" desde el paso activo — aparece nada
               más entre el activo y su vecino inmediato en esa dirección. -->
          <div class="d-flex align-items-center justify-content-center" style="padding: 10px 16px; background: #f7f7f7; gap: 10px;width:100%">
            <ng-container *ngFor="let step of getTramoSteps(); let idx = index; let last = last; trackBy: trackByIndex">
              <button
                type="button"
                class="tramo-step-btn"
                (click)="selectStep(idx)"
                [class.active]="selectedStepIndex === idx"
                [style.color]="'#000'"
                [style.font-weight]="'500'"
                style="background: none; border: none; font-size: 12px; letter-spacing: .5px; padding: 0; white-space: nowrap;width:100%"
              >
                {{ step.label }}
              </button>

              <button
                type="button"
                *ngIf="!last && idx === selectedStepIndex"

                style="background: none; border: none; color: #333; font-size: 16px; padding: 0;"
              >
                &rsaquo;
              </button>
              <button
                type="button"
                *ngIf="!last && idx + 1 === selectedStepIndex"

                style="background: none; border: none; color: #333; font-size: 16px; padding: 0;"
              >
                &lsaquo;
              </button>
            </ng-container>
          </div>

        </div>
      </div>

             <div class="usb-modal-experience-container pt-2" style="margin-bottom: 65px;margin-top: 45px">
                <p class="usb-modal-experience-subtitle mb-1" style="font-family: 'Poppins', sans-serif; font-size: 18px;font-weight: 600; padding: 0px 12px;">Información</p>

                <!-- Paso seleccionado = un tramo de vuelo -->
                <div class="row mt-4" *ngIf="getSelectedStep()?.type === 'tramo'">

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-4 pl-4 pr-2"
                    style="gap: 10px; border-right: 1px solid black;border-top: 1px solid black; "
                  >
                    <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Desde</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.departure?.airport }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-4 pl-4 pr-2" style="gap: 10px;border-top: 1px solid black;">
                    <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hasta</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.arrival?.airport }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-4 pl-4 pr-2"
                    style="gap: 10px;  border-right: 1px solid black;border-top: 1px solid black;"
                  >
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column" >
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hora de salida</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedSegment()?.departure?.dateTime) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-4 pl-4 pr-2" style="gap: 10px; border-top: 1px solid black">
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Hora de llegada</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedSegment()?.arrival?.dateTime) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-4 pl-4 pr-2"
                    style="gap: 10px; border-top: 1px solid black; border-right: 1px solid black;border-bottom: 1px solid black;"
                  >
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column" >
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Información de viaje</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">tiempo de vuelo: {{formatDuration(getSegmentDuration(getSelectedSegment()))}}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-4 pl-4 pr-2" style="gap: 10px; border-top: 1px solid black;border-bottom: 1px solid black;">
                  <img src="../../../../assets/icons/itinerary/vuelo_vert.svg" style="width: 16px;transform: rotate(45deg); flex-shrink: 0;" alt="">

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Vuelo</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ getSelectedSegment()?.airline?.code }} {{ getSelectedSegment()?.flightNumber }}</p>
                    </div>
                  </div>
                </div>

                </div>

                <!-- Paso seleccionado = una escala -->
                <div class="row mt-4" *ngIf="getSelectedStep()?.type === 'escala'">

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-3 px-2"
                    style="gap: 10px; border-right: 1px solid black;border-top: 1px solid black; "
                  >
                    <img src="../../../../../assets/icons/search-result/tour/gps.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Escala</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">
                        {{ getSelectedEscalaInfo()?.city }}<ng-container *ngIf="getSelectedEscalaInfo()?.country">, {{ getSelectedEscalaInfo()?.country }}</ng-container>
                      </p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-3 px-2" style="gap: 10px;border-top: 1px solid black;">
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Tiempo de Escala</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatDuration(getSelectedEscalaInfo()?.durationMinutes) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pr-0">
                  <div
                    class="d-flex align-items-start py-3 px-2"
                    style="gap: 10px;  border-right: 1px solid black;border-top: 1px solid black;border-bottom: 1px solid black;"
                  >
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column" >
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Inicio de Escala</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedEscalaInfo()?.startDateTime) }}</p>
                    </div>
                  </div>
                </div>

                <div class="col-6 pl-0">
                  <div class="d-flex align-items-start py-3 px-2" style="gap: 10px; border-top: 1px solid black;border-bottom: 1px solid black;">
                    <img src="../../../../../assets/icons/search-result/tiempo_uso.svg" width="18px" height="18px" alt="" />

                    <div class="d-flex flex-column">
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 500;">Fin de Escala</p>
                      <p class="mb-0" style="font-family: 'Rubik', sans-serif; font-size: 14px;font-weight: 400;">{{ formatTime(getSelectedEscalaInfo()?.endDateTime) }}</p>
                    </div>
                  </div>
                </div>

                </div>
             </div>


  <!-- Ancillaries / Extras (equipaje extra, etc.) — arriba de las tarifas -->
  <div *ngIf="loadingAncillaries" class="text-center" style="padding: 1rem 0; color: #666;">
    Buscando extras disponibles...
  </div>

  <div *ngIf="!loadingAncillaries && ancillaries.length > 0" style="margin-bottom: 1.5rem;">
    <p style="font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 600; margin-bottom: 10px;">Extras</p>

    <div class="d-flex flex-column" style="gap: 8px;">
      <div
        *ngFor="let ancillary of ancillaries"
        class="d-flex align-items-center justify-content-between px-3 py-2"
        style="border: 1px solid #e9ecef; border-radius: 8px;"
      >
        <div class="d-flex flex-column">
          <p class="mb-0" style="font-size: 13px; font-weight: 500; color: #333;">{{ ancillary.description }}</p>
          <p class="mb-0" style="font-size: 11px; color: #999;">{{ getAncillaryTypeLabel(ancillary.type) }}</p>
        </div>
        <div class="d-flex align-items-center" style="gap: 14px;">
          <p class="mb-0" style="font-size: 13px; font-weight: 600; color: #333;">
            {{ currencyAgency?.code }} {{ getAncillaryPrice(ancillary) | number: '1.2-2' }}
          </p>
          <input
            type="checkbox"
            [disabled]="processing"
            [checked]="isAncillarySelected(ancillary)"
            (change)="toggleAncillary(ancillary)"
          />
        </div>
      </div>
    </div>

    <p *ngIf="selectedAncillaries.length > 0" style="margin-top: 8px; margin-bottom: 0; font-size: 13px; text-align: right; color: #333;">
      Extras seleccionados: <strong>{{ currencyAgency?.code }} {{ getAncillariesTotal() | number: '1.2-2' }}</strong>
    </p>
  </div>

  <!-- Familias tarifarias -->
  <!-- <h5 style="font-weight: 600; margin-bottom: 1rem;">Tarifas disponibles</h5> -->

  <!-- Skeleton de tarjeta de tarifa: header (título) + descripción (mínimo
       4 renglones) + valor y dos frases más abajo, igual forma que la
       tarjeta real de más abajo. -->
  <div *ngIf="loadingFareOptions" class="d-flex" style="gap: 12px; overflow: hidden; padding: 4px 0;">
    <div *ngFor="let _ of [1, 2, 3, 4]" class="d-flex flex-column" style="flex: 1; min-width: 220px; border: 1px solid #e9ecef; border-radius: 10px; overflow: hidden;">
      <div style="padding: 10px 14px; height: 70px; display: flex; align-items: center; justify-content: center;">
        <span class="skeleton-shimmer skeleton-md"></span>
      </div>

      <div style="padding: 14px; flex: 1;">
        <span class="skeleton-shimmer skeleton-sm d-block mb-2"></span>
        <span class="skeleton-shimmer skeleton-sm d-block mb-2"></span>
        <span class="skeleton-shimmer skeleton-sm d-block mb-2"></span>
        <span class="skeleton-shimmer skeleton-sm d-block"></span>
      </div>

      <div style="padding: 14px; text-align: center;">
        <span class="skeleton-shimmer skeleton-price d-block mx-auto mb-2"></span>
        <span class="skeleton-shimmer skeleton-sm d-block mx-auto mb-1"></span>
        <span class="skeleton-shimmer skeleton-sm d-block mx-auto mb-3"></span>
        <span class="skeleton-shimmer d-block" style="height: 38px; border-radius: 50rem;"></span>
      </div>
    </div>
  </div>

  <div *ngIf="!loadingFareOptions && fareOptionsError" class="text-center" style="padding: 1.5rem; background-color: #fff3e0; border-radius: 8px;">
    <p style="margin-bottom: 10px; font-size: 14px;">No pudimos traer las tarifas alternativas para este vuelo.</p>
    <button
      type="button"
      class="btn"
      [disabled]="processing"
      (click)="chooseFare(null)"
      style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.4rem 1.2rem;"
    >
      Continuar con la tarifa original
    </button>
  </div>

  <!-- Sin alternativas (no es error, simplemente no hay otras tarifas): se
       monta directo lo que ya tenía el producto, es la única opción posible. -->
  <div *ngIf="!loadingFareOptions && !fareOptionsError && fareOptions.length === 0" class="text-center" style="padding: 1.5rem; background-color: #f7f7f7; border-radius: 8px;">
    <p style="margin-bottom: 10px; font-size: 14px;">No hay tarifas alternativas para este vuelo.</p>
    <button
      type="button"
      class="btn"
      [disabled]="processing"
      (click)="chooseFare(null)"
      style="background-color: #00d398; color: white; border-radius: 50rem; padding: 0.4rem 1.2rem;"
    >
      Continuar con la tarifa original
    </button>
  </div>

  <!-- usb-carousel (mismo carrusel compartido que usa destination-big/shortcuts): breakpoints
       para que se vean 4 tarjetas en el ancho del modal y menos en pantallas chicas.
       fareOptionsPadded completa con tarjetas "cerradas" (null) hasta 4 si hay menos
       tarifas, para que la grilla no quede con huecos / ancho irregular. -->
  <usb-carousel
    #fareCarousel
    *ngIf="!loadingFareOptions && !fareOptionsError && fareOptions.length > 0"
    [items]="fareOptionsPadded"
    [breakpoints]="fareCarouselBreakpoints"
    [showArrows]="fareOptionsPadded.length > 1"
    style="--usb-carousel-arrow-size: 20px; --usb-carousel-arrow-weight: 600; --usb-carousel-arrow-stroke-width: 1px;
      --usb-carousel-arrow-bg: #eeeeee; --usb-carousel-arrow-width: 40px; --usb-carousel-arrow-height: 40px;
      --usb-carousel-arrow-border-radius: 50%; --usb-carousel-arrow-offset-right: -16px; --usb-carousel-arrow-offset-left: -16px;"
  >
    <ng-template #slideTemplate let-fare let-i="index">
      <div *ngIf="fare; else closedFareCard" style="overflow: hidden; display: flex; flex-direction: column; height: 100%; margin: 0 6px;">
        <div
          [style.background-color]="getFareHeaderColor(fare)"
          [style.color]="getFareHeaderTextColor(fare)"
          style="padding: 10px 14px; font-size: 15px; border-top-left-radius: 10px;border-top-right-radius: 10px; height: 70px; display: flex; align-items: center;justify-content: center;"
        >
          <p style="font-family: 'Poppins', sans-serif;font-size: 14px;font-weight: 500;margin-bottom: 0px;text-align: center;"> {{ getFareLabel(fare) }}</p>
        </div>

        <div style="padding: 14px; flex: 1;border: 1px solid #e9ecef;  ">
          <div *ngFor="let group of getFareFeatureGroups(fare)" style="margin-bottom: 12px;">
            <p style="margin-bottom: 4px; font-size: 11px; font-weight: 700; text-transform: uppercase; color: #333;">
              {{ group.title }}
            </p>
            <ul style="padding-left: 18px; margin-bottom: 0;">
              <li *ngFor="let line of group.lines" style="font-size: 12px; color: #555; margin-bottom: 4px;">
                {{ line }}
              </li>
            </ul>
          </div>
        </div>

        <div style="padding: 14px; border: 1px solid #e9ecef; border-bottom-left-radius: 10px;border-bottom-right-radius: 10px;margin-bottom: 10px; text-align: center;">
          <div style="display: inline-block; text-align: left;">
            <p *ngIf="selectedAncillaries.length > 0" style="margin-bottom: 2px; font-size: 12px; color: #999; text-decoration: line-through;">
              {{ currencyAgency?.code }} {{ getFarePrice(fare) | number: '1.2-2' }}
            </p>
            <p style="margin-bottom: 2px; font-size: 20px; font-weight: 700; color: #333;">
              {{ currencyAgency?.code }} {{ getFareTotalWithAncillaries(fare) | number: '1.2-2' }}
            </p>
            <p *ngIf="selectedAncillaries.length > 0" style="margin-bottom: 0px; font-size: 11px; color: #999;">
              incluye {{ currencyAgency?.code }} {{ getAncillariesTotal() | number: '1.2-2' }} en extras
            </p>
            <p style="margin-bottom: 0px; font-size: 11px; color: #999;">Por pasajero</p>
            <p style="margin-bottom: 10px; font-size: 11px; color: #999;">incluye tasas e impuestos</p>
          </div>
        </div>

        <button
            type="button"
            class="btn w-100"
            [disabled]="processing"
            (click)="chooseFare(fare)"
            style="color: black;height: 52px;font-family: 'Poppins', sans-serif; font-size: 16px; font-weight: 600"
            [style.background-color]="clientsSettingAppBooking?.clients_setting_global?.color_main_1 || '#000000'"
          >
            {{ processing && isFareChosen(fare) ? 'Procesando...' : 'Elegir' }}
          </button>
      </div>

      <!-- Relleno de la grilla cuando hay menos de 4 tarifas: tarjeta "cerrada",
           sin datos ni botón funcional, con la misma forma/alto que una real. -->
      <ng-template #closedFareCard>
        <div style="overflow: hidden; display: flex; flex-direction: column; height: 100%; margin: 0 6px; opacity: 0.5;">
          <div style="padding: 10px 14px; height: 70px; border-top-left-radius: 10px; border-top-right-radius: 10px; background-color: #e9ecef;"></div>

          <div style="padding: 14px; flex: 1; border: 1px solid #e9ecef; display: flex; align-items: center; justify-content: center;">
            <i class="bi bi-x-lg" style="font-size: 28px; color: #adb5bd;"></i>
          </div>

          <div style="padding: 14px; border: 1px solid #e9ecef; border-bottom-left-radius: 10px; border-bottom-right-radius: 10px; margin-bottom: 10px; height: 101px;"></div>

          <div style="width: 100%; height: 52px; border-radius: 50rem; background-color: #e9ecef;"></div>
        </div>
      </ng-template>
    </ng-template>
  </usb-carousel>

</div>
</div>

